import { useQuery } from '@tanstack/react-query';
import type { EnforcedLawOptionDto } from '@munifocus/contracts-gov';
import { api } from './api-client';

export const enforcedLawKeys = {
  /**
   * Keyed by the local government, because the answer depends on it: the same
   * officer opening two files anchored at two municipalities must not be shown
   * one's by-laws on the other's file out of a shared cache.
   */
  byLocalGovernment: (localGovernmentId: string) =>
    ['enforced-laws', localGovernmentId || 'unanchored'] as const,
};

export async function listEnforcedLaws(localGovernmentId: string): Promise<EnforcedLawOptionDto[]> {
  const { data } = await api.get<EnforcedLawOptionDto[]>('/enforced-laws', {
    params: localGovernmentId ? { localGovernmentId } : undefined,
  });
  return data;
}

export function useEnforcedLaws(localGovernmentId: string) {
  return useQuery({
    queryKey: enforcedLawKeys.byLocalGovernment(localGovernmentId),
    queryFn: () => listEnforcedLaws(localGovernmentId),
    // Reference data an administrator changes rarely; refetching it on every
    // focus would be noise on a form the officer is mid-way through.
    staleTime: 5 * 60_000,
  });
}
